import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { useState } from 'react';
import { useEffect } from 'react';
import { Button, TextField, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { IoMdCloseCircle } from "react-icons/io";
import UpdateDialog from './UpdateModal';
import { getAgentDetails } from 'API/CspMapping/api';
import BackdropLoader from '../../General/Loader';





const paginationModel = { page: 0, pageSize: 5 };


const StyledDataGrid = styled(DataGrid)(({ theme }) => ({

  '& .MuiDataGrid-columnHeaders': {
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    backgroundColor: theme.palette.background.default,
  },
  // '& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader': {
  //   '&:nth-of-type(1)': {
  //     position: 'sticky',
  //     left: 0,
  //     backgroundColor: theme.palette.background.default,
  //     zIndex: 100,
  //   },
  //   '&:nth-of-type(2)': {
  //     position: 'sticky',
  //     left: 200,
  //     backgroundColor: theme.palette.background.default,
  //     zIndex: 100,
  //   },
  //   '&:nth-of-type(3)': {
  //     position: 'sticky',
  //     left: 330,
  //     backgroundColor: theme.palette.background.default,
  //     zIndex: 100,
  //   },
  // },
}));



export default function UnMappedAgentTable(props) {
  const [row, setRow] = useState([])
  const [Amount, setAmount] = useState({})

  const [OpenUpdateModal, setUpdateModal] = useState(false)
  const [SelectedData, setSelectedData] = useState(null)
  const [UpdatedData, setUpdatedData] = useState({})

  const [AgentData, setAgentData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const handleInputChange = (event, params) => {
    // console.log("event",event,params);
    if (/^[0-9]*$/.test(event.target.value)) {
      const userId = params.row.user_id;
      const newAmount = event.target.value ? parseInt(event.target.value) : "";
      setAmount((prevAmount) => ({
        ...prevAmount,
        [userId]: {
          ...prevAmount[userId],
          sh_amount: newAmount
        }
      }));
    }
  }


  const handleUpdateRequestAmount = (row, value) => {
    console.log("1");
    if (/^[0-9]*$/.test(value)) {
      console.log("2");
      const userId = row.user_id;
      const newAmount = value === "" ? 0 : parseInt(value);
      if (newAmount !== "") {
        setUpdatedData((prevData) => ({
          ...prevData,
          [userId]: newAmount
        }))
      }


    }
    else {
      console.log("3");
      setUpdatedData((prevData) => ({
        ...prevData,
        [row.user_id]: UpdatedData[row.user_id] ? UpdatedData[row.user_id] : 0
      }))
    }

  }

  useEffect(() => {
    props.setRmpostData(UpdatedData)
  }, [UpdatedData])

  const handleUpdateOpen = (row) => {
    setUpdateModal(true)
    setSelectedData(row)
  }

  const handleUpdateClose = () => {
    setUpdateModal(false)
    setSelectedData(null)
  }

  const handleInputAdd = (params) => {
    setAmount({ ...Amount, [params.row.user_id]: params.row })
  }
  useEffect(() => {
    if (props.data) {
      setRow(props.data)
    }
  }, [props.data])

  const handleRemoveItem = (params) => {
    const buffer = { ...params.row }
    const deleted = delete buffer.user_id
    console.log(params, deleted);

    setAmount(deleted)
  }

  console.log("rows", props);

  useEffect(() => {
    props.setSelectedData(Amount)
  }, [Amount])

  const columns = [
    //   { field: 'id', headerName: 'ID', width: 70 },
    { field: 'aadhaar_name', headerName: 'CSP Name', width: 200 },
    { field: 'csp_code', headerName: 'CSP Code', width: 130 },
    { field: 'bank_name', headerName: 'Bank', width: 130 },
    { field: 'retail_district', headerName: 'Location', width: 130 },
    { field: 'mobile_number', headerName: 'Mobile', width: 130 },
    { field: 'email_address', headerName: 'Email', width: 250 },
    {
      field: 'sh_amount',
      headerName: 'Requested Amount',
      width: 200,
      renderCell: (params) => (
        <TextField
          variant="outlined"
          value={
            sessionStorage.getItem("UserType") === "sh" ?
              props.status === "pending"&&UpdatedData && UpdatedData[params.row.user_id] && UpdatedData[params.row.user_id] !== "" ?
                UpdatedData[params.row.user_id]
                :
                props.status === "pending" ?
                  Amount[params.row.user_id] ?
                    Amount[params.row.user_id].sh_amount ?
                      Amount[params.row.user_id].sh_amount : "" : ""
                  :
                  params.row.sh_amount
              :
              sessionStorage.getItem("UserType") === "rm" ?
                params.row.sh_amount
                :
                sessionStorage.getItem("UserType") === "cso" ?
                  params.row.rm_amount?params.row.rm_amount:params.row.sh_amount
                  :
                  ""
          }
          disabled={Amount[params.row.user_id] || Amount[params.row.user_id] === "" ? false : true}
          sx={{
            input: {
              backgroundColor: Amount[params.row.user_id] || Amount[params.row.user_id] === "" ? 'inherit' : "#f2f2f2"
            }
          }}
          size='small'
          onChange={(event) => handleInputChange(event, params)}
        />
      ),
    },

    { field: 'updated_amount', 
      headerName: 'Updated Amount', 
      width: 250,
      renderCell:(params) =>(
        <Typography variant='body2'>{
          UpdatedData && UpdatedData[params.row.user_id] && UpdatedData[params.row.user_id] !== "" ?
            UpdatedData[params.row.user_id]
            :
            "-"
        }</Typography>
      ) 
    },

    {

      width: 150,
      renderCell: (params) => (
        props.status === "pending" ?
          Amount[params.row.user_id] || Amount[params.row.user_id] === "" ?
            <Button variant='contained' onClick={() => handleRemoveItem(params)}><IoMdCloseCircle /></Button>
            :
            sessionStorage.getItem("UserType") === "sh" ? <Button variant='contained' onClick={() => handleInputAdd(params)}>Select</Button>
              :
              sessionStorage.getItem("UserType") === "rm" ?
                <Button variant='contained' onClick={() => handleUpdateOpen(params.row)}>Edit</Button>
                :
                null
          :
          null
      ),
    },
  ];

  console.log("Props at", props);

  useEffect(() => {
    if (props.userDetails && props.status === "pending") {

      getAgentDetails(props.userDetails.request_id, setAgentData, setIsLoading)
    }
  }, [props.userDetails])


  useEffect(() => {
    if (AgentData) {
      props.setAgentDetails(AgentData)
    }
  }, [AgentData])

  return (
    <Paper sx={{ height: 400, width: '100%' }}>
      <BackdropLoader open={isLoading} />
      <UpdateDialog updatedData={UpdatedData} handleUpdateData={handleUpdateRequestAmount} data={SelectedData} open={OpenUpdateModal} handleClose={handleUpdateClose} />
      {
        sessionStorage.getItem("UserType") === "sh" ?
          <StyledDataGrid
            rows={props.status === 'pending' ? row : props.userDetails.agent_details ? props.userDetails.agent_details : []}
            columns={columns}
            initialState={{ pagination: { paginationModel } }}
            pageSizeOptions={[5, 10]}
            getRowId={(item) => item.user_id}
            sx={{ border: 0 }}
          />
          :
          sessionStorage.getItem("UserType") === "rm" || sessionStorage.getItem("UserType") === "cso" ?
            <StyledDataGrid
              rows={props.userDetails && props.userDetails.agent_details ? props.userDetails.agent_details : AgentData && AgentData.agent_details ? AgentData.agent_details : []}
              columns={columns}
              initialState={{ pagination: { paginationModel } }}
              pageSizeOptions={[5, 10]}
              getRowId={(item) => item.user_id}
              sx={{ border: 0 }}
            />
            :
            null
      }

    </Paper>
  );
}
